// extracted by mini-css-extract-plugin
export default {"container":"Hm-z","bubbleNav":"Im-z","graphic":"Jm-z","contact":"Km-z"};